<template lang="pug">
a(
  class="phone"
  :href="`tel:${value}`"
)
  | +{{ country }} ({{ code }})&nbsp;
  span {{ number }}
</template>

<script>
export default {
  props: {
    phone: {
      type: Number | Array,
      required: true
    }
  },
  computed: {
    clearSimbols() {
      return this.phone.replace(/[^0-9]/g, '');
    },

    value() {
      return this.clearSimbols ? this.clearSimbols : this.$slots.default.reduce((r, i) => `${r}${i.text}`, '');
    },

    country() {
      return this.value[0]
    },

    code() {
      return this.value.substring(1, 4)
    },

    number() {
      return this.value.substring(4, 7) + '-' + this.value.substring(7, 9) + '-' + this.value.substring(9)
    }
  }
}
</script>

<style lang="scss" scoped>
.phone {
  white-space: nowrap;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
  vertical-align: middle;
  text-decoration: none;

  span {
    font-weight: 700;
  }

  &:hover {
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// Phone.vue?c965cc20